export function extractVariablesInBrackets(input: string): string[] {
  const regex = /\[([^\[\]]+)]/g;
  const matches: string[] = [];
  let match;

  while ((match = regex.exec(input)) !== null) {
    matches.push(match[1].trim());
    const value = match[1].trim();
    // Bỏ qua nếu giá trị bên trong là một số (ví dụ: [1], [2.5], v.v.)
    if (isNaN(Number(value))) {
      matches.push(value);
    }
  }

  return Array.from(new Set(matches));
}
